module.exports = __webpack_public_path__ + "img/ios.d00a090a.png";